// extracted by mini-css-extract-plugin
module.exports = {"notifications-list":"notifications-list___Xps4J"};